import './recomendacao.scss'

const recomendacao = ({ recomendacao, nls }) => {
  if (!recomendacao) return null

  const obterAcao = valor => {
    if (valor === 'padronizar') return nls.recommendationActionStandardize
    if (valor === 'pivotar') return nls.recommendationActionPivot
    if (valor === 'escalonar') return nls.recommendationActionEscalate
    if (valor === 'encerrar') return nls.recommendationActionClose
    return valor || ''
  }

  const obterProximoNivel = valor => {
    if (valor === 'semanal') return nls.nextLevelWeekly
    if (valor === 'mensal') return nls.nextLevelMonthly
    return valor || ''
  }

  const possuiFalhasSimilares =
    Number.isInteger(recomendacao?.falhasSimilaresRecentes) &&
    recomendacao?.falhasSimilaresRecentes !== null

  const possuiConteudo =
    recomendacao?.acao ||
    recomendacao?.texto ||
    possuiFalhasSimilares ||
    recomendacao?.proximoNivel

  if (!possuiConteudo) return null

  return (
    <div
  className='recomendacao'
  data-cy='pdca-plan-detail-recommendation'
>
      <div className='recomendacao__title'>
        {nls.recommendationTitle.toUpperCase()}
      </div>

      <div className='recomendacao__content'>
        {recomendacao?.acao && (
          <div
  className='recomendacao__field'
  data-cy='pdca-plan-detail-recommendation-field'
  data-cy-key='action'
>
            <span className='recomendacao__label'>
              {nls.recommendationActionLabel}
            </span>
            <strong className='recomendacao__value'>
              {obterAcao(recomendacao.acao)}
            </strong>
          </div>
        )}

        {recomendacao?.texto && (
          <div
  className='recomendacao__field'
  data-cy='pdca-plan-detail-recommendation-field'
  data-cy-key='text'
>
            <span className='recomendacao__label'>
              {nls.recommendationTextLabel}
            </span>
            <strong className='recomendacao__value recomendacao__value--text'>
              {recomendacao.texto}
            </strong>
          </div>
        )}

        {(possuiFalhasSimilares || recomendacao?.proximoNivel) && (
          <div
  className='recomendacao__cards'
  data-cy='pdca-plan-detail-recommendation-cards'
>
            {possuiFalhasSimilares && (
              <div
  className='recomendacao__card'
  data-cy='pdca-plan-detail-recommendation-card'
  data-cy-key='similar-failures'
>
                <span className='recomendacao__label'>
                  {nls.similarFailuresRecentLabel}
                </span>
                <strong className='recomendacao__value recomendacao__value--highlight'>
                  {recomendacao.falhasSimilaresRecentes}
                </strong>
              </div>
            )}

            {recomendacao?.proximoNivel && (
              <div
  className='recomendacao__card'
  data-cy='pdca-plan-detail-recommendation-card'
  data-cy-key='next-level'
>
                <span className='recomendacao__label'>
                  {nls.nextLevelLabel}
                </span>
                <strong className='recomendacao__value recomendacao__value--highlight'>
                  {obterProximoNivel(recomendacao.proximoNivel)}
                </strong>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default recomendacao